<cng-agent-view-info-panel></cng-agent-view-info-panel> <cng-agent-view-planning></cng-agent-view-planning>
